import styled, { keyframes } from "styled-components";
import Animate from "./Animate";

const fadeInRight = keyframes`
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
`;

const FadeRightWrap = styled(Animate)`
    & {
      opacity: 0;
    }

    &.fadeRight{
        animation:${fadeInRight} 0.5s forwards;
    }
`;

FadeRightWrap.defaultProps = {
    effectClassName: "fadeRight"
};

export default FadeRightWrap;